  //Match height:
  var matchHeight = function(selector) {
    var elements = document.querySelectorAll(selector);
    var maxHeight = 0;
    for (var i = 0; i < elements.length; i++) {
      elements[i].style.height = 'auto';
      if (elements[i].offsetHeight > maxHeight) {
        maxHeight = elements[i].offsetHeight;
      }
    }
    for (var i = 0; i < elements.length; i++) {
      elements[i].style.height = maxHeight + 'px';
    }
  };
  
  /*
  window.onload = function() {
    matchHeight('.product-card .product-card__heading');
  };
  
  window.onresize = function() {
    matchHeight('.product-card .product-card__heading');
  };
    matchHeight('.product-card .product-card__heading');*/